import { render } from "./MarkdownReader.vue?vue&type=template&id=b248aa40&scoped=true"
import script from "./MarkdownReader.vue?vue&type=script&lang=js"
export * from "./MarkdownReader.vue?vue&type=script&lang=js"

import "./MarkdownReader.vue?vue&type=style&index=0&id=b248aa40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b248aa40"]])

export default __exports__